<template>
    <div class="md-banner broker" :style="{ marginBottom }">
        <banner
            ref="banner"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :style="bannerStyle"
            :type="type"
            :mobileType="mobileType"
            :sizeOption="sizeOption"
            :bgColor="bgColor"
            :mobileBgColor="mobileBgColor"
            :pictureOption="pictureOption"
            :pictureListOption="pictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
        >
            <div
                class="title-container f-col"
                :class="{ full: contentFull }"
                :style="contentStyle"
            >
                <div v-if="mode === 'agent'">
                    <h2
                        v-if="title"
                        class="title agent-mode"
                        :class="{
                            'top-line': showLine && linePos === 'top',
                            'left-line': showLine && linePos === 'left'
                        }"
                    >
                        <div
                            v-if="showLine"
                            class="line"
                            :style="lineStyle"
                        ></div>
                        <div class="text">{{ agent.fullName }}</div>
                    </h2>
                    <div class="sub-title agent-mode" v-if="agent.shortIntroduction" v-html="agent.shortIntroduction"></div>
                    <agent-share
                        :socialNetworks="agent.socialNetworks"
                    />
                    <div class="phone">
                        {{ $t('md-banner:phone')
                        }}<a
                            target="_top"
                            :href="'tel:' + agent.phone"
                            rel="noopener noreferrer"
                        >
                            {{ $ft.formatPhone(agent.phone) }}
                        </a>
                    </div>
                </div>
                <template v-else>
                    <div
                        v-if="title"
                        class="title after-line banner-mode"
                        :class="{
                            'top-line': showLine && linePos === 'top',
                            'left-line': showLine && linePos === 'left'
                        }"
                    >
                        <div
                            v-if="showLine"
                            class="line"
                            :style="lineStyle"
                        ></div>
                        <div v-if="!isBuildingDetail" class="text banner-mode" v-html="title" style="font-family:var(--mg-title-font)"></div>
                        <div v-if="buildingInfo.neighborhood" class="text banner-mode banner-mode-building" v-html="buildingInfo.neighborhood"></div>
                    </div>
                    <template v-if="!isBuildingDetail">
                        <div v-if="subTitle" class="sub-title banner-mode" v-html="subTitle" style="font-family:var(--font-medium)"></div>
                    </template>
                    <template v-else>
                        <div v-if="buildingInfo.neighborhoodDescription" class="sub-title banner-mode sub-title-building" v-html="buildingInfo.neighborhoodDescription"></div>
                    </template>
                </template>
                <div
                    v-if="useType === 'video' && videoOption.hidePlayButton"
                    class="video-button"
                >
                    <div class="play-video" @click.stop="doVideoPlay"></div>
                    <div class="video-loading"></div>
                </div>
            </div>
        </banner>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { useBuildingStore, usePageStore } from '@/store';
import common from '../index';

export default {
    mixins: [common],
    computed: {
        ...rootMapState(useBuildingStore, {
            "buildingInfo": "buildingInfo"
        }),
        ...rootMapState(usePageStore, {
            isBuildingDetail: store => store?.page?.pageKey === 'building'
        })
    },
    created() {
        if (this.isBuildingDetail) {
            this.resetPictureListOption();
        }
    },
    methods: {
        resetPictureListOption() {
            if (this.isBuildingDetail) {
                const neighborhoodPictures =
                    this.buildingInfo?.neighborhoodPictures || '';
                let picList;
                if (!neighborhoodPictures) {
                    picList = [
                        'https://cdn.chime.me/image/fs/sitebuild/2021617/19/original_58ade7ed-57d3-4d19-8d3a-982e2f806056.png'
                    ]; //  default picture
                } else {
                    picList = neighborhoodPictures.split(',');
                }
                this.pictureListOption.list = picList || [];
                this.pictureListOption.mobileList = picList || [];
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-banner.broker {
    .banner {
        .banner-video .play-video {
            z-index: 3;
        }
        .swiper-pagination-bullet {
            background-color: #ffffff;
            opacity: 0.5;
            @include media-1080 {
                width: 6px;
                height: 6px;
            }
            @include media-600 {
                width: 4px;
                height: 4px;
            }
        }
        .swiper-pagination-bullet-active {
            opacity: 1;
        }
    }
    .title-container {
        position: relative;
        z-index: 2;
        text-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
        .phone {
            float: left;
            line-height: 20px;
            height: 20px;
            margin-top: 21px;
            border-left: 1px solid #ddd;
            padding-left: 10px;
            margin-left: 10px;
        }
        .title {
            position: relative;
            padding-top: 30px;
            &.banner-mode {
                padding-bottom: 50px;
            }
            .iconfont {
                position: absolute;
                font-size: 26px;
                color: var(--color-theme);
                left: 50%;
                top: 0;
                transform: translate(-50%, -100%);
            }
            &.after-line::after {
                position: absolute;
                content: '';
                width: 150px;
                height: 2px;
                background: #fff;
                left: 50%;
                bottom: 27px;
                transform: translate(-50%, 0);
            }
            &.top-line {
                position: relative;
                margin-top: 30px;
                .line {
                    margin-bottom: 18px;
                    width: 51px;
                    height: 4px;
                    box-shadow: 0 1px 1px 0 rgba(8, 17, 38, 0.5);
                    @include color-theme('background-color');
                }
            }
            &.left-line {
                display: flex;
                .line {
                    width: 4px;
                    height: auto;
                    @include color-theme('background-color');
                    margin-right: 20px;
                    flex: none;
                }
                .text {
                    flex: 1;
                }
            }
            .text.banner-mode {
                font-size: 60px;
                font-family: var(--font-title);
                line-height: 1.1;
                @include webkitBox(none);
                // @include color-theme();
                p {
                    line-height: inherit;
                    overflow: hidden;
                }
                &.banner-mode-building {
                    text-align: center;
                }
            }
            &.agent-mode {
                font: 40px var(--font-bold);
            }
        }
        .sub-title {
            font-size: 20px;
            &.sub-title-building {
                font-family: var(--font-medium);
                line-height: 24px;
            }
        }
        .video-button {
            margin-top: 30px;
            display: flex;
            justify-content: center;
        }
        .play-video {
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site3/images/play.png)
                no-repeat;
            background-size: cover;
            cursor: pointer;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
        .video-loading {
            display: none;
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
        @include media-1080 {
            .title .text {
                font-size: 35px;
            }
        }
        @include media-800 {
            .title .text {
                font-size: 30px;
            }
        }
        @include media-600 {
            .title {
                padding-top: 30px;
                padding-bottom: 6px;
                &.banner-mode {
                    padding-bottom: 42px;
                }
                &:after {
                    width: 50px;
                    bottom: 20px;
                }
                &.top-line {
                    margin-top: 0px;
                    .line {
                        width: 40px;
                        height: 3px;
                        margin-bottom: 15px;
                    }
                }
                .text p {
                    font-size: 24px !important;
                }
            }
            .sub-title {
                font-size: 16px;
                margin-top: 0;
                p {
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
                    line-height: 2.08;
                }
            }
        }
    }
    .banner-video.autoplay + .title-container,
    .banner-video.is-play + .title-container {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .title-container {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }
    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
}
</style>
